import React, { useState, useEffect, useContext } from 'react';
import FieldText from '../../../components/FieldText/FieldText';
import FieldCheckBox from '../../../components/FieldCheckBox/FieldCheckBox';
import ButtonDefault from '../../../components/ButtonDefault/ButtonDefault';
import { API } from '../../../API/API';
import { UserContext } from '../../../context/UserContext';
import { message } from 'antd';
import { MessageConst } from '../../../const/MessageConst';
import FieldDate from '../../../components/FieldDate/FieldDate';
import { hideLoadScreen, showLoadScreen } from '../../../components/LoadScreen/LoadScreen';
import FieldItemList from '../../../components/FieldItemList/FieldItemList';
import PanelBase from '../../../components/PanelBase/PanelBase';

const Department = (props) => {

    const { userInfo } = useContext(UserContext);

    const [initialData] = useState({
        "depid": -1,
        "depcode": null,
        "name": null,
        "parentid": null,
        "companyid": userInfo.companyid.toUpperCase(),
        "path": null,
        "isactive": true,
        "establisheddate": null,
        "countryid": null
    })
    const [data, setData] = useState({ ...initialData });
    const [warning, setWarning] = useState();

    const getExistData = async () => {
        let tData = { ...initialData };
        showLoadScreen();
        await API.get('/api/humanresource/organization/get_department?depid=' + props.depid).then(response => {
            if (response.status == 200 && response.data.rettype == 0) {
                if (response.data.retdata?.length > 0) {
                    tData = response.data.retdata[0];
                }
            }
        });
        hideLoadScreen();
        setData(tData);
    }

    useEffect(() => {
        if (props.depid > 0) {
            getExistData();
        }
    }, [props.depid])

    const fieldOnChanged = (key, text, field, fieldname) => {
        if (field) {
            let tData = { ...data };
            tData[field] = key;
            if (fieldname) {
                tData[fieldname] = text;
            }
            setData(tData);
        }
    }

    const onSave = async () => {
        setWarning();
        let vRule = true;

        if (!data.name) {
            vRule = false;
            setWarning("Нэгжийн нэр" + MessageConst.fieldRequired);
        }

        if (vRule) {
            showLoadScreen();
            await API.post('/api/humanresource/organization/save_department', [data]).then(response => {
                if (response.status == 200 && response.data.rettype == 0) {
                    message.success(MessageConst.success);
                    setData({ ...initialData });
                    props.afterSave();
                }
            });
            hideLoadScreen();
        }
    }

    const deleteP = async () => {
        showLoadScreen();
        await API.post('api/humanresource/organization/delete_department?depid=' + props.depid).then(response => {
            if (response.status == 200 && response.data.rettype == 0) {
                message.success(MessageConst.success);
                props.afterSave();
            }
        });
        hideLoadScreen();
    }

    const onDismiss = () => {
        setData({ ...initialData });
        setWarning();
        props.onDismiss();
    }

    return (
        <div>
            <PanelBase
                isOpen={props.isOpen}
                onDismiss={onDismiss}
                headerText={props.depid > 0 ? "Дотоод нэгж засах" : "Дотоод нэгж нэмэх"}
                isFooterAtBottom={true}
                onDelete={deleteP}
                warning={warning}
                delete={props.depid}
                buttons={
                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <ButtonDefault onClick={onSave} full text="Хадгалах" />
                    </div>
                }
            >
                <div style={{ marginTop: 25 }}>
                    <FieldItemList title="Харьяалах дээд дотоод нэгж" onChanged={fieldOnChanged} keyfield='parentid' keyfieldname='parentname' defaultValue={[{ key: data.parentid, name: data.parentname }]} dataurl={'/api/humanresource/organization/get_department_dropdown'} dataparam={[{ key: 'companyid', name: userInfo.companyid.toUpperCase() }, { key: 'depid', name: data.depid }]} />
                </div>
                <div style={{ marginTop: 13 }}>
                    <FieldText disable={true} title="Нэгжийн код" onChanged={fieldOnChanged} keyfield='depcode' defaultValue={data.depcode ? data.depcode : null} />
                </div>
                <div style={{ marginTop: 13 }}>
                    <FieldText title="Нэгжийн нэр" onChanged={fieldOnChanged} keyfield='name' defaultValue={data.name ? data.name : null} />
                </div>
                <div style={{ marginTop: 13 }}>
                    <FieldText title="Дотоод нэгжийн дэлгэрэнгүй" onChanged={fieldOnChanged} keyfield='path' defaultValue={data.path ? data.path : null} />
                </div>
                <div style={{ marginTop: 13 }}>
                    <FieldItemList
                        title="Дотоод нэгжийн төрөл"
                        onChanged={fieldOnChanged}
                        keyfield='deptypeid'
                        keyfieldname='deptypename'
                        defaultValue={[{ key: data.deptypeid, name: data.deptypename }]}
                        dataurl="/api/humanresource/organization/get_department_type_dropdown" />
                </div>
                <div style={{ marginTop: 13 }}>
                    <FieldDate title="Байгуулагдсан огноо" onChanged={fieldOnChanged} keyfield='establisheddate' defaultValue={data.establisheddate ? data.establisheddate : null} />
                </div>
                <div style={{ marginTop: 13 }}>
                    <FieldItemList title="Байрших улс" onChanged={fieldOnChanged} keyfield='countryid' keyfieldname='countryname' defaultValue={[{ key: data.countryid, name: data.countryname }]} dataurl="/api/humanresource/organization/get_country_dropdown" saveurl="/api/humanresource/organization/save_country" />
                </div>
                <div style={{ marginTop: 13 }}>
                    <FieldCheckBox title="Идэвхтэй эсэх" onChanged={fieldOnChanged} keyfield='isactive' defaultValue={data.isactive != undefined ? data.isactive : true} />
                </div>
            </PanelBase>
        </div>
    );
}

export default Department;